import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import ContainerTmpCard from "./ContainerTmpCard";

export default function ContainerTemplate({ title, description, cardsData }) {
  return (
    <Box
      sx={{
        width: "100%",
        py: {
          xs: "30px",
          customBreakpoint: "48px",
        },
        px: {
          xs: "16px",
          customBreakpoint: "24px",
          md: "84px",
        },
      }}
    >
      {/* Header */}
      <Box sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            fontSize: {
              xs: "24px",
              customBreakpoint: "32px",
              md: "40px",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 2,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              customBreakpoint: "16px",
              md: "18px",
            },
            fontWeight: 400,
            textAlign: "center",
            color: "#666666",
            lineHeight: 1.7,
            mb: 5,
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* GRID */}
      <Box
        sx={{
          display: "grid",

          // Columns
          gridTemplateColumns: {
            xs: "1fr",
            customBreakpoint: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },

          // According to Figma
          gap: "24px",

          // Align Cards CENTER
          justifyItems: "center",
        }}
      >
        {cardsData.map((item, index) => (
          <ContainerTmpCard key={index} {...item} />
        ))}
      </Box>
    </Box>
  );
}
